<ion-content class="w-full h-full p-8">
  <swiper-container #slideContainer [modules]="swiperModules" pagination="true">
    <swiper-slide class="ion-padding">
      <div>
        <img class="will-change-transform" src="../../assets/slide1.png" >

        <div class="slider-text">
          <ion-text>
            <h2>Automatisierung</h2>
          </ion-text>
          
          <ion-text>
            <p>
              Quick Drive automatisiert nahezu alle deine Büroarbeiten - Mehr Zeit für deine Schüler:innen, weniger Aufwand für Verwaltung und Buchhaltung.
            </p>
          </ion-text>
        </div>
      </div>
      <div class="navigator">
        <ion-button color="primary" fill="outline" shape="round" (click)="next()">WEITER</ion-button>
      </div>
    </swiper-slide>
    <swiper-slide class="ion-padding">
      <img class="will-change-transform" src="../../assets/slide2.png" >

      <div class="slider-text">
        <ion-text>
          <h2>Finanzen</h2>
        </ion-text>

        <ion-text>
          <p>
            Erstelle Rechnungen und Zahlungen mit nur wenigen Klicks. Quick Drive führt deinen Zahlungsverlauf automatisch nach und zeigt dir deine offenen Rechnungen an.
          </p>
        </ion-text>
      </div>

      <div class="navigator">
        <ion-button color="primary" fill="outline" shape="round" (click)="next()">WEITER</ion-button>
      </div>
    </swiper-slide>
    <swiper-slide class="ion-padding">
      <img class="will-change-transform" src="../../assets/slide3.png" >

      <div class="slider-text">
        <ion-text>
          <h2>Terminplanung</h2>
        </ion-text>

        <ion-text>
          <p>
            Quick Drive erleichtert dir die Planung mit einem übersichtlichen Kalender, den du ganz einfach mit deinem privaten Kalender synchronisieren kannst.
          </p>
        </ion-text>
      </div>
      <div class="navigator">
        <ion-button color="primary" shape="round" (click)="completeOnboardingClick()">Jetzt loslegen!</ion-button>
      </div>
    </swiper-slide>
  </swiper-container>
</ion-content>